import React from 'react';
import { motion } from 'framer-motion';
const WhyUsStats = () => {
  return (
    <>
    <div className="w-full bg-[#fbfcff] relative overflow-hidden h-[fit-content]  lg:h-screen">
      <div className="max-w-6xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8 py-8 sm:py-10 md:py-12 lg:py-16">
        <div className="w-full lg:w-7/12">
          
          {/* Left Column - Content */}
          <div className="space-y-6 sm:space-y-7 md:space-y-8 relative z-10">
            
            {/* Title */}
            <div className="space-y-2 max-w-md">
              <span className="text-2xl sm:text-3xl md:text-4xl lg:text-4xl xl:text-5xl font-source italic font-regular text-[#113861]">
                Industry 
              </span>
              <span className="mx-2 sm:mx-3 text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-source font-light text-[#113861] mb-4">
                we service
              </span>
             
            </div>

            {/* Subtitle */}
            <div className="space-y-3 sm:space-y-4">
              <h3 className="text-base sm:text-lg lg:text-xl font-sans font-semibold text-[#113861]">
                Tailored Clarity for Transformative Outcomes
              </h3>
              <p className="text-xs sm:text-sm md:text-sm lg:text-base font-sans font-regular text-[#2b2b2b] leading-relaxed">
                Clarity looks different for everyone. That's why we design personalised solutions for diverse learners, educators, and institutions.
              </p>
            </div>

            {/* Two Column Services */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-7 md:gap-8 lg:gap-12">
              
              {/* Left Services Column */}
              <div className="space-y-4 sm:space-y-5 md:space-y-6">
                
                {/* Education Section */}
                <div className="space-y-2 sm:space-y-3">
                  <div className="flex items-start flex-col space-x-0">
                    <div className="w-8 h-8 sm:w-9 sm:h-9 md:w-10 md:h-10 transform rotate-90 flex items-center justify-center mb-2">
                      {/* <div className="w-1 h-1 bg-white transform rotate-45"></div> */}
                      <img src="/images/arrow-bulltin.png" alt="Education" className="w-full h-full" />
                    </div>
                    <h4 className="text-sm sm:text-base md:text-base lg:text-lg font-sans font-semibold text-[#113861] uppercase tracking-wide">
                      EDUCATION
                    </h4>
                  </div>
                  <h5 className="text-xs sm:text-sm md:text-sm lg:text-base font-sans font-regular text-[#113861]">
                    Empowering students and institutions through self-awareness
                  </h5>
                  <p className="text-xs lg:text-sm font-sans font-regular text-[#2b2b2b] leading-relaxed">
                    Our tools help schools uncover students' strengths and thinking styles early, improving engagement and planning. In higher education, we support universities in shaping future-ready graduates through psychometric assessments that align learning with real-world goals.
                  </p>
                </div>

              </div>

              {/* Right Services Column */}
              <div className="space-y-4 sm:space-y-5 md:space-y-6">
                
                {/* Social Sector Section */}
                <div className="space-y-2 sm:space-y-3">
                  <div className="flex items-start flex-col space-x-0">
                    <div className="w-8 h-8 sm:w-9 sm:h-9 md:w-10 md:h-10 transform rotate-90 flex items-center justify-center mb-2">
                      {/* <div className="w-1 h-1 bg-white transform rotate-45"></div> */}
                      <img src="/images/arrow-bulltin.png" alt="Education" className="w-full h-full" />
                    </div>
                    <h4 className="text-sm sm:text-base md:text-base lg:text-lg font-sans font-semibold text-[#113861] uppercase tracking-wide">
                      SOCIAL SECTOR
                    </h4>
                  </div>
                  <h5 className="text-xs sm:text-sm md:text-sm lg:text-base font-sans font-regular text-[#113861]">
                    Partnering for equity and access
                  </h5>
                  <p className="text-xs lg:text-sm font-sans font-regular text-[#2b2b2b] leading-relaxed">
                    We believe clarity should be for all. By working with NGOs and education trusts, we bring science-backed tools to underserved communities, turning uncertainty into confidence where it matters most.
                  </p>
                </div>

              </div>
              
            </div>

           

          </div>

          {/* Right Column - Spacer for layout */}
          <div className="hidden lg:block">
            {/* This div maintains the grid layout while the image is absolutely positioned */}
          </div>
          
        </div>
      </div>

      {/* Absolutely Positioned Right Image - Hidden on smaller screens */}
      <div className="hidden lg:block absolute top-0 right-0 h-full pointer-events-none">
        <div className="relative w-full h-full flex items-center justify-center lg:justify-end">
          <div className="relative w-full h-full">
            
            {/* Main Image */}
            <div className="relative w-full h-full">
              <img 
                src="/images/ColorfulRootTub 1.png" 
                alt="Colorful Root Tub Design" 
                className="w-full h-full object-cover lg:object-cover"
                style={{
                  maxHeight: '100vh',
                  minHeight: '500px',
                  width: 'clamp(400px, 35vw, 650px)',
                  height: 'clamp(500px, 80vh, 700px)',
                  mixBlendMode: 'multiply'
                }}
              />
            </div>
            
          </div>
        </div>
        
      </div>
     {/* Bottom CTA Section */}
    
    </div>
     <div className="relative overflow-hidden rounded-lg">
     {/* Diagonal Gradient Background */}
     <div 
       className="w-[full] h-full p-4 sm:p-5 md:p-6 lg:p-8 py-3 sm:py-4"
       style={{
         background: 'linear-gradient(90deg, #113861 0%, #113861 100%)',
         clipPath: 'polygon(0 0%, 100% 95%, 100% 100%, 0 100%)'
       }}
     >
       {/* Light Blue Top Border */}
       <div 
         className="absolute top-0 left-0 w-full h-0.5"
         style={{
           background: '#93C5FD',
           clipPath: 'polygon(0 0%, 100% 95%, 100% 60%, 0 0%)'
         }}
       ></div>
       
       {/* Light Blue Bottom Border */}
       <div 
         className="absolute top-0 left-0 w-full h-0.5"
         style={{
           background: '#93C5FD',
           clipPath: 'polygon(0 0%, 100% 95%, 100% 60%, 0 0%)',
           transform: 'translateY(40px)'
         }}
       ></div>
       
       {/* Content */}
       <div className="relative top-2 sm:top-3 md:top-4 z-10 space-y-0 text-start max-w-6xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8 py-3 sm:py-4">
         <h4 className="text-base sm:text-lg lg:text-xl font-sans font-regular text-white">
           Rooted in <span className="text-lime-400 font-bold">Science.</span>
         </h4>
         <p className="text-sm sm:text-base lg:text-lg font-sans font-regular text-white">
           Shaping the <span className="text-lime-400 font-bold">Future.</span>
         </p>
       </div>
     </div>
   </div>
    </>
  );
};

export default WhyUsStats;